import { ListProps } from "@logicsoftware/react-virtualized";
import { isFunction } from "lodash";
import * as React from "react";
import { ReactElement, ReactNode } from "react";
import { PopoverProps } from "~/sharedComponents/popover";

export type TriggerProps = {
    isOpened: boolean;
    isLoading: boolean;
    isDisabled: boolean;
};

export type SelectChildren = Partial<
    Pick<ListProps, "isLoading"> &
        Pick<PopoverProps, "disabled"> & {
            /** used for old AC only to fix members popup position */
            hideTrigger?: boolean;
            children: ReactNode | F1<TriggerProps, ReactElement>;
        }
>;

export const useSelectTrigger = ({
    children,
    hideTrigger,
    isOpened,
    disabled,
    isLoading,
}: SelectChildren & Pick<TriggerProps, "isOpened">) => {
    if (hideTrigger) {
        return <span />;
    }

    return isFunction(children)
        ? children({
              isOpened,
              isLoading,
              isDisabled: disabled,
          })
        : children;
};
